import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import get from 'lodash/fp/get';
import { CONTENT_ARCHIVE } from 'config/types/prop';
import { options } from 'config/reactRedux';
import { connect } from 'react-redux';
import createGetTranslation from 'selectors/i18n';
import ThemeProvider from 'components/hoc/themeProvider';
import ContentList from 'components/contentList';
import Meta from 'components/meta';
import I18n from 'components/i18n';
import ShowMoreButton from 'components/showMoreButton';
import useAccessibilityFocusLastAfterLoading from 'hooks/useAccessibilityFocusLastAfterLoading';
import Helmet from 'react-helmet';

import AuthorHeader from './header';

import styles from './contentArchiveAuthor.css';

const ContentArchiveAuthor = ({
  pagination: { hasMore },
  items,
  loadingMore,
  onLoadMore,
  currentEdition,
  getTranslation,
}) => {
  const onFocus = useAccessibilityFocusLastAfterLoading({ loading: loadingMore });
  const showLoadMore = hasMore || loadingMore;
  const hasItems = !!items.length;
  const author = get('0.metadata.coauthors.0', items);
  const {
    absolutePath: authorAbsolutePath,
    displayName,
    firstName,
    relativePath: authorRelativePath,
  } = author || {};

  const magazineName = getTranslation('meta-title', 'Babbel Magazine');
  const titleText = `${displayName} - ${magazineName}`;

  return (
    <section className={styles.wrapper}>
      <Meta title={titleText} />
      <h1 className="hidden">{titleText}</h1>
      <Helmet>
        <link rel="author" href={authorRelativePath} />
        <link rel="canonical" href={authorAbsolutePath} />
      </Helmet>
      <div className={styles.content}>
        {author && <AuthorHeader
          {...author}
          currentEdition={currentEdition}
        />}
        <div className={styles.articlesHeader}>
          <I18n
            field="articles-by"
            defaultText="Articles by"
          />
          &nbsp;{firstName}
        </div>
        <div className={styles.archiveList}>
          {hasItems ?
            <ThemeProvider themes={{
              DefaultListViewItem: 'threeUp',
              ContentList: 'threeUp',
            }}
            >
              <ContentList
                items={items}
                interstitials={[
                  {
                    frequency: 3,
                    count: Infinity,
                    content: <div className={styles.divider} />,
                  },
                ]}
                onFocus={onFocus}
              />
            </ThemeProvider>
            :
            <div className={styles.empty}>
              <h2 className={styles.emptyHeading}>No articles</h2>
            </div>
          }
        </div>
        {showLoadMore &&
          <ShowMoreButton
            onClick={onLoadMore}
            disabled={loadingMore}
            loading={loadingMore}
          />
        }
      </div>
    </section>
  );
};

ContentArchiveAuthor.propTypes = CONTENT_ARCHIVE;

const mapStateToProps = (state) => ({
  getTranslation: createGetTranslation(state),
});

const withRedux = connect(
  mapStateToProps,
  undefined,
  undefined,
  options,
);

const wrapWithStyles = withStyles(styles);

export default wrapWithStyles(withRedux(ContentArchiveAuthor));
